import dayjs from 'dayjs';

import { getRandomInRange } from '@r1-frontend/shared/helpers/getRandomInRange';

export const generateAbtTestValue = () => {
    const dayNow = dayjs().unix() * 1000;
    const randomValue = getRandomInRange(0, 100);

    return `${dayNow}.${randomValue}`;
};
